











































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import MovieRate from '../../enums/movieRate';
import ServiceAgent from '../../services/serviceAgent';

const serviceAgent = new ServiceAgent();

@Component
export default class BottomButtons extends Vue {
    @Prop() movieId!: string;

    @Prop() movieRate!: MovieRate;

    @Prop() movieRateChangedCallback: any;

    MovieRate = MovieRate;

    changeMovieRate(movieRate: MovieRate) {
        let rate = movieRate;

        if (this.movieRate === movieRate) {
            rate = MovieRate.notRated;
        }

        this.movieRateChangedCallback(this.movieId, rate);
    }
}
